import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f6619c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "checking"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "正在自动验机"),
  /*#__PURE__*/_createElementVNode("div", null, "请勿关闭当前页面")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 当前识别到您的设备已经脱保，需要完成验机方可购买"),
  /*#__PURE__*/_createElementVNode("span", null, "保险。验机形式为自动验机，您需在购保前 48 小时内"),
  /*#__PURE__*/_createElementVNode("span", null, "完成一次正常飞行，留空时间需大于 3 分钟，系统会自"),
  /*#__PURE__*/_createTextVNode("动分析日志判断设备状态。 ")
], -1))
const _hoisted_5 = {
  key: 1,
  class: "unlog"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "当前设备无近48小时内的"),
  /*#__PURE__*/_createElementVNode("div", null, "飞行日志")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "验机不通过，请重新操作设备悬停 3 分钟后再次验机。", -1))
const _hoisted_9 = {
  key: 2,
  class: "error"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "当前设备最近一个架次"),
  /*#__PURE__*/_createElementVNode("div", null, "状态异常")
], -1))
const _hoisted_12 = { class: "verify-error-desc desc" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验机不通过，暂不支持投保！", -1))
const _hoisted_14 = { class: "contact-us" }

import { Loading, Button } from 'vant'
import { clearToast } from '@/utils/tools'
import { getDeviceTestInfo } from '@/apis/insurance'
import { TestDeviceResult } from '@/types/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { useCustomServiceInfo } from '@/compositions/insurance/index'
import { ref, Ref, withDefaults, computed, watch, nextTick } from 'vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import CommonPopupWrap from '@/components/popup/common-wrap.vue'
import DialogErrorSvg from '@/assets/insurance/dialog-error.svg'
import DialogWarningSvg from '@/assets/insurance/dialog-warning.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'auto-check',
  props: {
    show: { type: Boolean, default: false },
    sn: { default: '' }
  },
  emits: ['update:show', 'testSuccess'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, sn: string };



const checkValue = 'check'
const unLogValue = 'unlog'
const errorValue = 'error'
const mode = ref(checkValue)
const testResultInfo: Ref<null | TestDeviceResult> = ref(null)
const { phone, callHandle } = useCustomServiceInfo()
const isChecking = computed(() => mode.value === checkValue)
const isUnlog = computed(() => mode.value === unLogValue)
const isError = computed(() => mode.value === errorValue)

watch(
  () => props.show,
  () => {
    if (props.show && props.sn) {
      startVerify()
    }
  }
)
const vantPopupProps = computed(() => {
  return {
    'close-on-click-overlay': !isChecking.value,
    onClosed() {
      mode.value = checkValue
    },
  }
})
function updateShow(value: boolean) {
  emits('update:show', value)
}

async function startVerify() {
  mode.value = checkValue
  // 开始验机
  if (!props.sn) {
    return
  }

  try {
    const data = await getDeviceTestInfo(props.sn)
    testResultInfo.value = data
    if (data.check_result === 'SUCCESS') {
      // 验机成功
      emits('testSuccess', data)
    } else {
      // 失败的情况
      const type = String(data.error_type)
      if (type === '1') {
        mode.value = unLogValue
      } else if (type === '2') {
        mode.value = errorValue
      }
    }
    clearToast()
  } catch (error) {
    emits('update:show', false)
    commonErrorHandle(error)
  }
}
function cancel() {
  // 返回
  updateShow(false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPopupWrap, {
    show: props.show,
    teleport: "body",
    title: "脱保自动验机",
    "onUpdate:show": updateShow,
    "header-style": {
      backgroundColor: 'white',
    },
    "vant-popup-props": _unref(vantPopupProps),
    showHeaderClose: !_unref(isChecking)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isChecking))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading), {
                size: "48",
                color: "#39B54A"
              }),
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        (_unref(isUnlog))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _unref(DialogWarningSvg),
                alt: "",
                class: "icon-img"
              }, null, 8, _hoisted_6),
              _hoisted_7,
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (_unref(isError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _unref(DialogErrorSvg),
                alt: "",
                class: "icon-img"
              }, null, 8, _hoisted_10),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", null, "架次时间：" + _toDisplayString(testResultInfo.value?.fly_start_at || '-'), 1),
                _createElementVNode("span", null, "异常原因：" + _toDisplayString(testResultInfo.value?.data?.warnings?.[0]?.msg || '-'), 1)
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createTextVNode("如有疑问，请联系 "),
                _createElementVNode("span", {
                  class: "phone-number",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(callHandle) && _unref(callHandle)(...args)))
                }, _toDisplayString(_unref(phone)), 1),
                _createTextVNode("。")
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(CommonFooterWrap, { class: "footer-button" }, {
          default: _withCtx(() => [
            (_unref(isUnlog))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  class: "reverify-btn",
                  onClick: startVerify
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重新验机")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isError))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 1,
                  class: "cancel-btn",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "vant-popup-props", "showHeaderClose"]))
}
}

})